export enum GoalDefinitionTypeEnum {
  Predefined = 1,
  Custom = 2
}

export const GoalDefinitionTypeOptions = [
{ id: 1, label: 'Predefined' },
{ id: 2, label: 'Custom' }
];
